import { Card, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import CheckIcon from 'components/icons/Check';
import { baseColors } from 'utils/constants';

type Props = {
  width: number;
  number: string;
  title: string;
  recommendLists?: string[];
  recommendTexts?: string[];
  recommendAttentions?: string[];
};

const RecommendCard = (props: Props) => {
  const { width, number, title, recommendLists = [], recommendTexts = [], recommendAttentions = [] } = props;

  return (
    <Card sx={{ width: `${width}px`, paddingBottom: '20px', boxShadow: 'none' }}>
      <Typography
        variant="h5"
        sx={{
          display: 'flex',
          fontSize: '18px',
          padding: '10px 0',
          textAlign: 'center',
          alignItems: 'center'
        }}
      >
        <span
          style={{
            fontSize: '14px',
            color: baseColors.red,
            fontWeight: 700,
            lineHeight: 1
          }}
        >
          POINT
          <br />
          <span style={{ fontSize: '32px' }}>{number}</span>
        </span>
        <span style={{ paddingLeft: '15px', fontSize: '22px' }}>{title}</span>
      </Typography>
      <Stack
        direction="row"
        spacing={0}
        sx={{
          padding: '0',
          justifyContent: 'space-around',
          alignItems: 'center'
        }}
      >
        <List
          sx={{
            backgroundColor: baseColors.lightPink,
            width: '100%',
            padding: '10px 0'
          }}
        >
          {recommendLists.map((item, index) => (
            <ListItem key={index} sx={{ padding: '3px 15px' }}>
              <ListItemIcon sx={{ minWidth: '20px' }}>
                <CheckIcon style={{ color: baseColors.red, width: '0.85em' }} />
              </ListItemIcon>
              <ListItemText>{item}</ListItemText>
            </ListItem>
          ))}
          {recommendTexts.map((item, index) => (
            <ListItem key={index} sx={{ padding: '3px 15px' }}>
              <ListItemIcon sx={{ minWidth: '20px' }}>
                <CheckIcon style={{ color: baseColors.red, width: '0.85em' }} />
              </ListItemIcon>
              <ListItemText>{item}</ListItemText>
            </ListItem>
          ))}
          {recommendAttentions.map((item, index) => (
            <ListItem key={index} sx={{ padding: '3px 15px' }}>
              <ListItemText>{item}</ListItemText>
            </ListItem>
          ))}
        </List>
      </Stack>
    </Card>
  );
};
export default RecommendCard;
